import { GridKubernetesResourceDataResponse } from "@/store/resources-grid/utils/types/resources";

export const accumulateAiKubernetesRecommendationIdFromResource = (
  resource: GridKubernetesResourceDataResponse,
) => {
  const resourceData = resource.resource;
  const namespace = "namespace" in resourceData ? resourceData.namespace : "";

  switch (resourceData.resource_type) {
    case "kubernetes_namespace":
    case "kubernetes_node":
      return `${resourceData.cluster.provider_id ?? ""}-${resourceData.name}`;

    case "kubernetes_deployment":
    case "kubernetes_job":
    case "kubernetes_pod":
    case "kubernetes_stateful_set":
    case "kubernetes_daemon_set":
      return `${resourceData.cluster.provider_id ?? ""}-${namespace}-${resourceData.name}`;

    default:
      return undefined;
  }
};
